var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localValue)?_c('form-fields',{key:JSON.stringify(_vm.value),attrs:{"schema":_vm.formSchema,"col":12,"micro":_vm.micro,"filled":""},on:{"change":_vm.onChange,"focus":_vm.onFocus,"blur":_vm.onBlur},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }